import { Box, Flex, Image } from "@chakra-ui/react";
import styles from "./Community.module.scss";
import gameIconMobile from "../../../assets/aimon/community_mobile.png";
// import gameIcon from "../../../assets/aimon/bg-bottom.png";

// Partnerships
// Exclusive Collaborations
// Join Us
// AIMon is committed to building strong partnerships with industry leaders to expand our ecosystem. Our collaborations with top blockchain projects and gaming studios ensure that AIMon remains at the forefront of innovation, providing our community with unparalleled experiences and opportunities
// We are excited to announce upcoming partnerships with renowned brands that will bring unique crossovers and exclusive content to the AIMon universe. These collaborations will introduce new Vimons, special events, and limited-edition merchandise, enriching the AIMon experience for all players
// Stay connected and never miss an update by following AIMon on our social media channels. Share your Vimon adventures, showcase your collections, and contribute to the growing AIMon story. Together, we can create a dynamic and thriving metaverse.

const texts = [
  {
    title: "Partnerships",
    text: "AIMon is committed to building strong partnerships with industry leaders to expand our ecosystem. Our collaborations with top blockchain projects and gaming studios ensure that AIMon remains at the forefront of innovation, providing our community with unparalleled experiences and opportunities.",
  },
  {
    title: "Exclusive Collaborations",
    text: "We are excited to announce upcoming partnerships with renowned brands that will bring unique crossovers and exclusive content to the AIMon universe. These collaborations will introduce new Vimons, special events, and limited-edition merchandise, enriching the AIMon experience for all players.",
  },
  {
    title: "Join Us",
    text: "Stay connected and never miss an update by following AIMon on our social media channels. Share your Vimon adventures, showcase your collections, and contribute to the growing AIMon story. Together, we can create a dynamic and thriving metaverse.",
  },
];

export default function Community() {
  const isMobile = window.innerWidth < 768;

  if (isMobile) {
    return (
      <Flex width={"100%"} flexDir={"column"} justifyContent={"flex-start"}>
        <Box
          as="img"
          src={gameIconMobile}
          alt="mobileIcon"
          width="100%"
          display="block"
          margin="0"
        />

        <Flex
          bgColor={"#FFA500"}
          color={"black"}
          flexDir={"column"}
          justifyContent={"flex-start"}
          gap={"80px"}
          padding={"40px 20px"}
          mt={"-3px"}
        >
          <Flex flexDir={"column"} alignItems={"flex-start"} gap={"20px"}>
            <Box fontSize={"36px"} lineHeight={"36px"} fontWeight={"700"}>
              Community
            </Box>
            <Box
              fontSize={"14px"}
              lineHeight={"18.2px"}
              fontWeight={"400"}
              textAlign={"left"}
            >
              Join our community to stay up to date with the latest news and
              updates about AIMon. Our community members are the first to know
              about new features, events, and partnerships.
            </Box>
          </Flex>

          <Flex flexDir={"column"} alignItems={"flex-start"} gap={"40px"}>
            {texts.map((text) => (
              <Flex flexDir={"column"} alignItems={"flex-start"} gap={"20px"}>
                <Box fontSize={"24px"} lineHeight={"24px"} fontWeight={"700"}>
                  {text.title}
                </Box>
                <Box
                  fontSize={"14px"}
                  lineHeight={"18.2px"}
                  fontWeight={"400"}
                  textAlign={"left"}
                >
                  {text.text}
                </Box>
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
    );
  }

  return (
    <Flex className={styles.container} id="community">
      {/* <img src={gameIcon} alt="logo" className={styles.gameIcon} /> */}

      <Box className={styles.bgGroup} />

      <Flex className={styles.contentWrapper}>
        <Flex className={styles.contentGroup1}>
          <Box className={styles.contentTitle}>Community</Box>
          <Box className={styles.contentText}>
            Join our community to stay up to date with the latest news and
            updates about AIMon. Our community members are the first to know
            about new features, events, and partnerships.
          </Box>
        </Flex>

        <Flex className={styles.contentGroup2Wrapper}>
          {texts.map((text) => (
            <Flex className={styles.contentGroup2}>
              <Box className={styles.contentTitle}>{text.title}</Box>
              <Box className={styles.contentText}>{text.text}</Box>
            </Flex>
          ))}
        </Flex>
      </Flex>
    </Flex>
  );
}
